var productHistory = {
    save_name: 'history_product',
    save_num: 16,
    init: function (product_id, get_num) {
        let that = this;
        that.now_product_id = product_id;
        if (location.href.indexOf("/products/") != -1) {
            that.addHistory(product_id)
        }
        return that.getHistory(get_num);
    },
    addHistory: function () {
        let that = this;
        if (!localStorage[that.save_name]) {
            that.historyLis = []
        } else {
            that.historyLis = JSON.parse(localStorage[that.save_name])
        }
        let product_ids = $.map(that.historyLis, (item) => {
            if (item != that.now_product_id) return item
        });
        if (product_ids.length >= that.save_num) {
            product_ids = $.map(product_ids, (i, k) => {
                if (k >= 1) {
                    return i
                }
            })
        }
        product_ids.push(that.now_product_id)
        localStorage[that.save_name] = JSON.stringify(product_ids)
    },
    getHistory: function (num = 8) {
        let that = this;
        if (!localStorage[that.save_name]) {
            that.historyLis = []
        } else {
            that.historyLis = JSON.parse(localStorage[that.save_name])
        }
        let product_ids = $.map($.map(that.historyLis, (item) => {
            if (item != that.now_product_id) return item
        }), (item, k) => {
            if (k >= num) return;
            return item
        });
        if (product_ids.length == 0) {
            var a = async ()=>{
              return;
            };
            return a()
        }
        let url = that.retGetUrl(product_ids)
        console.log('加载链接', url)
        return $.AjaxPromise({
            url: url,
        })
    },
    retGetUrl: function (product_ids) {
        return '/search?q=' + $.map(product_ids, (item) => {
            return 'id:' + item
        }).join("+OR+") + '&view=add'
    },
}